export default __webpack_public_path__ + "static/favicon-a106a7123739fe248c0a46ab326f490e.ico";